__turbopack_context__.v({
  "className": "geistsans_45141a47-module__mpR_0W__className",
  "variable": "geistsans_45141a47-module__mpR_0W__variable",
});
